import styled from "styled-components";

const ease = "cubic-bezier(0.2, 0.7, 0.2, 1)";

export const SubMenuWrapper = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  padding-top: 32px;
  border-top: 1px solid rgba(250, 251, 255, 0.12);
  @media (max-width: 768px) {
    width: calc(100% - 40px);
    padding-top: 24px;
  }
`;

export const SubMenuContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  color: rgba(250, 251, 255, 0.72);
  flex: 1;
  padding-left: 16%;
  @media (max-width: 768px) {
    padding-left: 0;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }
`;

export const Menu = styled.div`
  padding: 5px;
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 14px;
    text-align: center;
  }
`;

export const MenuItem = styled.span`
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  line-height: 1.6;
  p {
    margin: 0;
  }
  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const Address = styled(MenuItem)`
  display: flex;
  gap: 10px;
  svg {
    flex: 0 0 auto;
    width: 18px;
    height: 18px;
    margin-top: 2px;
    fill: none;
    stroke: #02c5ff;
    stroke-width: 1.6;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
`;

export const MenuItemLink = styled.a`
  color: rgba(250, 251, 255, 0.72);
  text-decoration: none;
  background: linear-gradient(currentColor, currentColor) no-repeat left bottom / 0 1px;
  transition: background-size 0.35s ${ease}, color 0.25s ease;
  &:hover,
  &:focus-visible {
    color: #fff;
    background-size: 100% 1px;
    outline: none;
  }
`;

export const ToTop = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(250, 251, 255, 0.22);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  transition: transform 0.3s ${ease}, background-color 0.3s ease, border-color 0.3s ease;
  svg {
    width: 18px;
    height: 18px;
    fill: none;
    stroke: #fafbff;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  &:hover,
  &:focus-visible {
    transform: translateY(-3px);
    background: #0043ff;
    border-color: #0043ff;
    outline: none;
  }
  @media (max-width: 768px) {
    margin-top: 10px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const SocialIcons = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    gap: 12px;
    margin: 14px 0 8px;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      border: 1px solid rgba(250, 251, 255, 0.22);
      border-radius: 50%;
    }
    img {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }
  }
`;
